export { default } from './TeamsAboutPage';
